<template>
  <div>
    <el-card class="box-card" body-style="min-height:74vh;">
      <div slot="header" class="clearfix">
        <el-form :model="searchForm" ref="searchForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="活动搜索：" prop="name">
            <el-input class="mt-search-width" v-model="searchForm.name" placeholder="请输入活动名称搜索"></el-input>
            <el-button type="primary" style="margin-left: 12px;" @click="searchTopBtn">查询</el-button>
          </el-form-item>
        </el-form>
        <el-button @click="editBtn('')" size="small" type="primary" class="bg-theme">添加活动</el-button>
      </div>
      <div class="text item">
        <el-table
          border
          :data="infoList">
          <el-table-column
            align="center"
            prop="id"
            label="ID">
          </el-table-column>
          <el-table-column
            align="center"
            prop="goodsName"
            label="活动商品名称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="goodsSpecName"
            label="活动商品规格">
          </el-table-column>
          <el-table-column
            align="center"
            prop="fullPieceNumber"
            label="满件数量">
          </el-table-column>
          <el-table-column
            align="center"
            prop="startDateTime"
            label="活动时间">
            <template slot-scope="scope">
              <span>{{scope.row.startDateTime+'~'+scope.row.endDateTime}}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="状态">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.status"
                active-color="#13ce66"
                inactive-color="#CCCCCC"
                @change="switchChangeBtn(scope.row.id)">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="createTime"
            label="创建时间">
          </el-table-column>
          <el-table-column
            align="center"
            width="240"
            label="操作">
            <template slot-scope="scope">
              <el-button @click="toManageBtn(scope.row.id)" type="text" size="small">赠品管理</el-button>
              <el-button @click="editBtn(scope.row.id)" type="text" size="small">编辑</el-button>
              <el-button @click="delBtn(scope.row.id)" v-loading.fullscreen.lock="fullscreenLoading" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="mt-page-bottom flex-end-row">
          <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { queryGiveawayPageList, removeGiveawayById, enableGiveawayById } from '@/api/giftPromotion'
export default {
  name: 'GiftPromotion',
  data () {
    return {
      imgServer: this.$imgServer,
      limitLength: this.$limitLength,
      pageTotal: 0,
      currentPage: 1,
      infoList: [],
      fullscreenLoading: false,
      searchForm: {
        name:''
      }
    }
  },
  mounted () {
    this.getInfoList()
  },
  methods: {
    // 搜索操作
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    // 获取数据
    getInfoList () {
      let that = this
      let searchName = that.searchForm.name
      let page = that.currentPage
      queryGiveawayPageList({ name: searchName,pageNum: page, pageSize: that.limitLength}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          data.forEach(function(item){
            item.status = item.status == 1 ? true : false;
          });
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 分页改变操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      this.getInfoList();
    },
    // 跳转赠品管理
    toManageBtn (infoId) {
      this.$router.push({path: '/gift_manage', query: {dataId: infoId}})
    },
    /* 编辑 */
    editBtn (infoId) {
      this.$router.push({path: '/gift_promotion_add', query: {dataId: infoId}})
    },
    // 开启或禁用操作
    switchChangeBtn(infoId){
      let that = this
      enableGiveawayById({ id: infoId}).then((res) => {
          if (res.errorCode === '0000') {
            this.$message({
              message: res.msg,
              type: 'success',
              onClose () {}
            })
          }
          if (res.errorCode === '1001') {
            this.$message.error(res.msg)
          }
        })
    },
    /* 删除 */
    delBtn (infoId) {
      let that = this
      this.$confirm('确认删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.fullscreenLoading = true
        removeGiveawayById({ ids: [infoId]}).then((res) => {
          that.fullscreenLoading = false
          if (res.errorCode === '0000') {
            this.$message({
              message: res.msg,
              type: 'success',
              onClose () {
                that.getInfoList()
              }
            })
          }
          if (res.errorCode === '1001') {
            this.$message.error(res.msg)
          }
        })
      }).catch(() => {})
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/market/GiftPromotion/GiftPromotion.vue